// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/variables.scss
// module id = spAd
// module chunks = 73